export default {
    aboveContent: 'above-content',
    floating: 'floating',
    overlay: 'overlay',
    overlayContent: 'overlay-content',
    aboveOverlayContent: 'above-overlay-content',
    topmost: 'topmost',
};
